import { ModalWelcomeValue, RoutesEnum } from '~/enums'

export function useEvents() {
  const router = useRouter()
  const route = useRoute()
  const INDEX_MODAL = '1'
  const INDEX_MAX_MODAL = '2'
  const { isLogged } = useUser()

  const isVisibleWelcomePopup = ref(false)
  const isShowFloating = ref(true)

  const setHasPopupEvent = (value: string): void => {
    useCookie('hasModalWelcome').value = value
  }

  const redirectToEvent = () => {
    router.push(RoutesEnum.EventDrawingLots)
    isShowFloating.value = false
    isVisibleWelcomePopup.value = false
    setHasPopupEvent(ModalWelcomeValue.Hidden)
  }

  const closePopup = () => {
    setHasPopupEvent(ModalWelcomeValue.Hidden)
    isVisibleWelcomePopup.value = false
  }

  const closeFloating = () => {
    isShowFloating.value = false
  }

  watch(
    () => route.path,
    (value) => {
      const hasModalWelcome = useCookie('hasModalWelcome')
      const numberModalWelcome = useCookie('numberModalWelcome')

      if (!hasModalWelcome.value && value !== RoutesEnum.EventDrawingLots) {
        isVisibleWelcomePopup.value = true
        numberModalWelcome.value = INDEX_MODAL
      }

      isShowFloating.value = value !== RoutesEnum.EventDrawingLots
    },
    { immediate: true },
  )

  watch(
    () => isLogged.value,
    () => {
      const numberModalWelcome = useCookie('numberModalWelcome')

      if (
        isLogged.value &&
        numberModalWelcome.value?.toString() === INDEX_MODAL &&
        route.path !== RoutesEnum.EventDrawingLots
      ) {
        isVisibleWelcomePopup.value = true
        setHasPopupEvent(ModalWelcomeValue.Hidden)
        numberModalWelcome.value = INDEX_MAX_MODAL
      }
    },
    { immediate: true },
  )

  return {
    isVisibleWelcomePopup,
    isShowFloating,
    closeFloating,
    redirectToEvent,
    closePopup,
  }
}
